"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  hover: ':hover',
  focus: ':focus',
  required: ':required',
  placeholder: '::placeholder',
  checked: ':checked',
  invalid: ':invalid',
  disabled: ':disabled',
  firstChild: ':first-child',
  lastChild: ':last-child',
  onlyChild: ':only-child',
  firstOfType: ':first-of-type',
  lastOfType: ':last-of-type',
  onlyOfType: ':only-of-type',
  active: ':active',
  checkedAndDisabled: ':checked:disabled'
};
exports["default"] = _default;